import React, { useEffect, useState } from "react";
import apiClient from "../../../GlobalUtilities/BaseUrl/apiClient";
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Dialog, DialogTitle, DialogContent, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import WhatsAppButton from "../../../GlobalUtilities/whatsapp/WhatsAppButton";
import {
  Button,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import CustumTextField from "../../../GlobalComponents/CustomComponant/CustomTextField";

const SearchComponent = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchOption, setSearchOption] = useState("TR Number"); // Default to 'TR Number'
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [crHeaders, setCrHeaders] = useState([]);
  const [crData, setCrData] = useState([]);
  const [drHeaders, setDrHeaders] = useState([]);
  const [drData, setDrData] = useState([]);
  const [error, setError] = useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const [statioName,setStationName]=useState("");
  const[oldTR,setoldTR]=useState("");
  const[oldAmount,setoldAmount]=useState("");

  const [showModal, setShowModal] = useState(false);
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [editMessage, setEditMessage] = useState("");
  const handleSearchTermChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchOptionChange = (event) => {
    setSearchOption(event.target.value);
    setSearchTerm("");
    setMonth("");
    setYear("");
    setShowModal(false);
  };

  const handleMonthChange = (event) => {
    setMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  const handleSearchSubmit = async (event) => {
    setPageLoader(true);
    event.preventDefault();
    setError("");
    setCrData([]);
    setDrData([]);
    setShowModal(false);
    try {
      let response;
      if (searchOption === "TR Number") {
        response = await apiClient.post("/search", {
          userid: "amit",
          searchTerm: searchTerm,
        });
      } else if (searchOption === "Amount") {
        response = await apiClient.post("/searchbydate", {
          userid: "amit",
          searchTerm: searchTerm,
          month: month,
          year: year,
        });
      }

      if (response.data && Array.isArray(response.data.data)) {
        const data = response.data.data;
        const crTransformed = transformData(data[0] || []);
        const drTransformed = transformData(data[1] || []);

        setCrHeaders(getHeaders(data[0] || []));
        setCrData(crTransformed);
        setDrHeaders(getHeaders(data[1] || []));
        setDrData(drTransformed);
      } else {
        setError("Unexpected response structure or empty data.");
      }
    } catch (err) {
      console.error("Error fetching data:", err.message, err.response?.data);
      setError("There was an error fetching data.");
    }

    setPageLoader(false);
  };

  const transformData = (data) => {
    return data.map((item) => ({ ...item }));
  };

  const getHeaders = (data) => {
    if (!data.length) return [];
    const allKeys = data.reduce((keys, item) => {
      Object.keys(item).forEach((key) => keys.add(key));
      return keys;
    }, new Set());
    return Array.from(allKeys);
  };

  const Table = ({ headers, rows }) => {
    // Filter out "Matched Status" from the headers for display
    const filteredHeaders = headers.filter(header => header !== "Matched Status");
  
    return (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
        }}
      >
        <thead>
          <tr>
            {filteredHeaders.map((header, index) => {
              return (
                <th
                  key={index}
                  style={{
                    border: "1px solid black",
                    padding: "8px",
                    textAlign: "left",
                  }}
                >
                  {header} {/* Display the original header */}
                </th>
              );
            })}
            {/* Add "Edit" column header */}
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "left",
              }}
            >
              Edit
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => {
            // Check if the value in the "Matched Status" column is 1
            const isMatchedStatusOne = row["Matched Status"] === 1;
  
            return (
              <tr key={rowIndex}>
                {filteredHeaders.map((header, colIndex) => {
                  // Check if this column should have a green background
                  const isGreenBackground =
                    (header === "TR NUMBER" ||
                      header === "Amount" ||
                      header === "Bank Remark" ||
                      header === "Station" ||
                      header === "Entry Month" ||
                      header === "Entry Year") &&
                    isMatchedStatusOne;
  
                  return (
                    <td
                      key={colIndex}
                      style={{
                        border: "1px solid black",
                        padding: "8px",
                        backgroundColor: isGreenBackground ? "lightgreen" : "",
                      }}
                    >
                      {row[header] || ""}
                    </td>
                  );
                })}
                {/* Add the Edit button in the new "Edit" column */}
                <td style={{ border: "1px solid black", padding: "8px" }}>
                  {!isMatchedStatusOne && (
                    <IconButton
                      color="primary"
                      onClick={() => handleEdit(row, filteredHeaders)} // Pass row and filteredHeaders to handleEdit
                    >
                      <EditIcon />
                    </IconButton>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };
  
  const handleEdit = (row, headers) => {
    const rowData = headers.map((header) => `${header}: ${row[header]}`).join(", ");
    const message = headers.includes("Depot")
      ? `Update: Debit Data\n`
      : `Update: Credit Data\n`;

    setEditMessage(message);
    
    // Set input values
    const stationName = row["Bank Remark"] ? row["Bank Remark"] : row.Station;
    setStationName(stationName);
    setoldTR(row["TR NUMBER"]);
    setoldAmount(row.Amount);
    
    setShowModal(true);
};

  
  useEffect(() => {
    // Reset data when search option changes
    setCrData([]);
    setDrData([]);
    setError('');
    setShowModal(false);
  }, [searchOption,month,year,searchTerm]);


  // useEffect(() => {
  //   if (showModal) {
  //     const timer = setTimeout(() => setShowModal(false), 5000); // Auto-close after 5 seconds
  //     return () => clearTimeout(timer);
  //   }
  // }, [showModal, setShowModal]);
  
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <div>
      {pageLoader && (
        <div className="loaderContainer">
          <CircularProgress />
        </div>
      )}

      <h1>Search Your TR</h1>

      <form onSubmit={handleSearchSubmit}>
        <FormControl fullWidth style={{ marginBottom: "16px" }}>
          <InputLabel id="search-option-label">Search By</InputLabel>
          <Select
            labelId="search-option-label"
            value={searchOption}
            onChange={handleSearchOptionChange}
          >
            <MenuItem value="TR Number">TR Number</MenuItem>
            <MenuItem value="Amount">Amount</MenuItem>
          </Select>
        </FormControl>

        <CustumTextField
          value={searchTerm}
          onChange={handleSearchTermChange}
          //placeholder={`Enter TR Number Minimum ${searchOption === 'TR Number' ? '5' : '1'} Character`}
          placeholder={`${searchOption === "TR Number" ? "Enter TR Number Minimum 5 Character" : "Enter Amount Minimum 1 Character"} `}
        />

        {searchOption === "Amount" && (
          <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
            <FormControl style={{ minWidth: "120px" }}>
              <InputLabel id="month-label">Month</InputLabel>
              <Select
                labelId="month-label"
                value={month}
                onChange={handleMonthChange}
              >
                {Array.from({ length: 12 }, (_, i) => (
                  <MenuItem key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString("default", {
                      month: "long",
                    })}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl style={{ minWidth: "120px" }}>
              <InputLabel id="year-label">Year</InputLabel>
              <Select
                labelId="year-label"
                value={year}
                onChange={handleYearChange}
              >
                {Array.from({ length: 10 }, (_, i) => {
                  const currentYear = new Date().getFullYear();
                  const yearValue = currentYear - i;
                  return (
                    <MenuItem key={i} value={yearValue}>
                      {yearValue}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
        )}

        <Button
          type="submit"
          disabled={
            searchOption === "TR Number"
              ? searchTerm.length <= 4
              : searchTerm.length < 1
          }
        >
          Search
        </Button>

      </form>

      

      <Dialog open={showModal} onClose={() => setShowModal(false)}>
     
       
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>




      <DialogTitle>{editMessage}</DialogTitle>
      <DialogContent>
      <TextField
          fullWidth
          margin="normal"
          label="Station Name"
          value={statioName}
         // onChange={(e) => setInput1(e.target.value)}
          variant="outlined"
          disabled={true}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Old TR NUMBER"
          value={oldTR}
         // onChange={(e) => setInput1(e.target.value)}
          variant="outlined"
          disabled={true}
        />

<TextField
          fullWidth
          margin="normal"
          label="Enter New TR NUMBER"
          value={input1}
          onChange={(e) => setInput1(e.target.value)}
          variant="outlined"
         // disabled={true}
        />

        <TextField
          fullWidth
          margin="normal"
          label="Old Amount"
          value={oldAmount}
        //  onChange={(e) => setInput2(e.target.value)}
          variant="outlined"
          disabled={true}
        />

<TextField
          fullWidth
          margin="normal"
          label="Enter New Amount"
          value={input2}
          onChange={(e) => setInput2(e.target.value)}
          variant="outlined"
         // disabled={true}
        />
        <Button
          fullWidth
          variant="contained"
          color="success"
          sx={{ mt: 2 }}
          onClick={() => setShowModal(false)}
        >
          Update & Close
        </Button>
      </DialogContent>
    </Dialog>







      {error && <p style={{ color: "red" }}>{error}</p>}

      {(crData.length > 0 || drData.length > 0) && (
        <>
          <div>
            <h1>Credit Data</h1>
            <Table headers={crHeaders} rows={crData} />
            <h1>Debit Data</h1>
            <Table headers={drHeaders} rows={drData} />
          </div>
        </>
      )}



<WhatsAppButton/>

    </div>
  );
};

export default SearchComponent;
